// 模拟分页查询
export function numList(body) {
    var { pageNo, pageSize, orgLevel } = body
    var totalCount = 33, // 总数
        totalPage = Math.ceil(totalCount / pageSize)

    return new Promise((resolve) => {
        var list = []

        if (pageNo <= totalPage) {
            var len = pageNo * pageSize

            for (
                var i = len - pageSize + 1;
                i <= Math.min(len, totalCount);
                i++
            ) {
                list.push({
                    id: i,
                    title: `第${i}行`,
                    publishStatus: i % 2,
                    orgLevel: orgLevel || (i % 4) + 1,
                    createTime: new Date(),
                })
            }
        }

        resolve({
            code: 200,
            data: {
                page: {
                    list,
                    pageNo,
                    pageSize,
                    totalCount,
                    totalPage,
                },
            },
        })
    })
}

// 模拟新增
export function numAdd(body) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve({
                code: 200,
            })
        }, 100)
    })
}
// 模拟更新
export function numUpdate(body) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve({ code: 200 })
        }, 100)
    })
}
// 模拟查看
export function numView(body) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve({
                code: 200,
                data: {
                    entity: {
                        title: '首发',
                        publishStatus: '1',
                        orgLevel: '3',
                    },
                },
            })
        }, 100)
    })
}

// 模拟删除
export function numDel(id) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve({ code: 200 })
        }, 100)
    })
}
